// src/pages/NotFoundPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Header />
      <main className="pt-32 pb-20 px-4 text-center">
        <h1 className="text-6xl font-bold mb-4">404</h1>
        <p className="text-2xl text-slate-400 mb-8">Page not found</p>
        <Link to="/">
          <Button className="bg-blue-500 hover:bg-blue-700">
            Go back home
          </Button>
        </Link>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;